module.exports = __webpack_public_path__ + "img/2018-08-21.89dd9d12.jpg";